  import { FileText, Clock, AlertCircle, CheckCircle, X } from 'lucide-react';
  import axios from './axios';
  import { showToast } from './toast';
  
  export const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'submitted':
      case 'new submission':
      case 'correction_submitted':
      case 'revision_submitted':
        return 'text-purple-800 bg-purple-50 border-purple/50';
      case 'under review':
      case 'review_submitted':
      case 'under_editor_decision':
        case 'under_editorial_review':
        return 'status-yellow';
      case 'revision required':
      // case 'returned_for_revision':
      // case 'returned_for_correction':
      //   return 'status-orange';
      case 'accepted':
        return 'status-green';
      case 'rejected':
        return 'status-red';
      case 'published':
        return 'status-purple';
      case 'pending':
        return 'status-yellow';
      case 'accepted':
        return 'status-green';
      case 'declined':
        return 'status-red';
      case 'invite_sent':
        return 'status-yellow';
     case 'pending':
     return 'bg-yellow-100 text-yellow-800 border-yellow-200';
     case 'invite_sent': 
        return'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'under_editor_decision':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      default:
       return getStatusColor(status);
        // return 'status-gray';
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      draft: 'bg-gray-100 text-gray-800 border-gray-200',
      saved: 'bg-gray-100 text-gray-800 border-gray-200',
      saved_for_later: 'bg-gray-100 text-gray-800 border-gray-200',

      drafted: 'bg-gray-100 text-gray-800 border-gray-200',
      revision_saved: 'bg-gray-100 text-gray-800 border-gray-200',
      correction_saved: 'bg-gray-100 text-gray-800 border-gray-200',
      submitted: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      revision_started: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',


      revision_submitted: 'bg-yellow-100 text-yellow-800 border-yellow-200',

      under_review: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      review_invitation_accepted: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      review_invitation_rejected: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      review_submitted: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      returned_for_revision: 'bg-blue-100 text-blue-800 border-blue-200',
      returned_for_correction: 'bg-[#ffedd5] text-[#9a3412] border-blue-200',
      accepted: 'bg-green-100 text-green-800 border-green-200',
      rejected: 'bg-red-100 text-red-800 border-red-200'
    };
    return colors[status] || 'bg-gray-100 text-gray-800 border-gray-200';
  };

  export const formatStatus = (status) => {
    if (!status) return 'Unknown';
    if(status === 'pending'){
      return "Awaiting your decision"
    }
    return status.split('_').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  };

export  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch (e) {
      return dateString;
    }
  };

export  const getStatusIcon = (status) => {
    switch(status) {
      case 'draft':
      case 'saved':
      case 'drafted':
      case 'revision_saved':
      case 'correction_saved':
        return <FileText className="w-3 h-3 mr-1" />;
      case 'submitted':
      case 'under_review':
      case 'review_invitation_accepted':
      case 'review_invitation_rejected':
      case 'review_submitted':
        return <Clock className="w-3 h-3 mr-1" />;
      case 'returned_for_revision':
      case 'returned_for_correction':
        return <AlertCircle className="w-3 h-3 mr-1" />;
      case 'accepted':
        return <CheckCircle className="w-3 h-3 mr-1" />;
      case 'rejected':
        return <X className="w-3 h-3 mr-1" />;
      default:
        return null;
    }
  };


  // Outside the component
const STATUS_BADGES = {
  returned_for_revision:  { text: 'Action Required',     cls: 'bg-yellow-100 text-yellow-800' },
  returned_for_correction:{ text: 'Action Required',     cls: 'bg-yellow-100 text-yellow-800' },
  revision_saved:         { text: 'Continue Revision',   cls: 'bg-purple-100 text-purple-800' },
  correction_saved:       { text: 'Continue Correction', cls: 'bg-purple-100 text-purple-800' },
  draft:                  { text: 'Continue Submission', cls: 'bg-blue-100 text-blue-800' },
  saved:                  { text: 'Continue Submission', cls: 'bg-blue-100 text-blue-800' }
};

// Helper component
export const StatusBadge = ({ status }) => {
  const badge = STATUS_BADGES[status];
  if (!badge) return null;
  return (
    <span className={`ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${badge.cls}`}>
      {badge.text}
    </span>
  );
};


const getDownloadName = (url = '') => {
  try {
    const { pathname } = new URL(url, window.location.origin);
    const name = decodeURIComponent(pathname.split('/').filter(Boolean).pop() || '');
    return name || 'download';
  } catch {
    return 'download';
  }
};

const readBlobError = async (blob) => {
  const text = await blob.text();
  try {
    return JSON.parse(text)?.error || text;
  } catch {
    return text;
  }
};

export const handleDownloadFile = async (fileUrl, label) => {
  if (!fileUrl) return;

  try {
    showToast('Preparing download...', 'info');

    // Always go through your own backend — never the remote host directly.
    const response = await axios.get('/api/files/download', {
      params: { url: fileUrl, filename: label },
      responseType: 'blob'
    });

    const cd = response.headers['content-disposition'] || '';
    let downloadName = getDownloadName(fileUrl);
    const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)/i.exec(cd);
    if (match?.[1]) {
      try {
        downloadName = decodeURIComponent(match[1]);
      } catch {
        downloadName = match[1];
      }
    }

    const blob = new Blob([response.data], {
      type: response.headers['content-type'] || 'application/octet-stream'
    });
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = downloadName;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
  } catch (err) {
    console.error('Download failed:', err);

    const status = err.response?.status;
    let message = 'Failed to download file. Please try again.';

    if (status === 403) {
      const serverError = err.response?.data instanceof Blob
        ? await readBlobError(err.response.data).catch(() => null)
        : err.response?.data?.error || null;
      message = serverError || 'Download denied: file must be served from an allowed host.';
    } else if (status === 404) {
      message = 'File not found. It may have been removed.';
    }

    showToast(message, 'error');
  }
};

export const generateRandomToken = (length = 30) => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const max = Math.floor(0xFFFFFFFF / charset.length) * charset.length;
  let token = '';

  while (token.length < length) {
    const buf = new Uint32Array(length - token.length);
    crypto.getRandomValues(buf);
    for (const v of buf) {
      if (v < max) token += charset[v % charset.length];
      if (token.length === length) break;
    }
  }
  return token;
};


export const sanitizeEmail = (encoded) => {
  if (!encoded || typeof encoded !== 'string') return '';

  try {
    // decodeURIComponent handles %40 → @, %2B → +, etc.
    // Replace literal '+' with space first, only if you're dealing with
    // application/x-www-form-urlencoded values (query strings sent as form data).
    // For standard URI-encoded values, '+' is already '%2B', so this line is safe.
    return decodeURIComponent(encoded.replace(/\+/g, ' ')).trim().toLowerCase();
  } catch (e) {
    // Malformed input (e.g. a lone '%') — return as-is so nothing crashes
    console.warn('Failed to decode email:', encoded, e);
    return encoded.trim().toLowerCase();
  }
};

/**
 * Ensures a URL/path has a proper leading format.
 * @param {string} url - The URL or path to normalize.
 * @param {'slash' | 'http' | 'https' | 'protocol'} checkFor - What to check for.
 * @returns {string} The normalized URL/path.
 */
export const ensureLeading = (url, checkFor = 'slash') => {
  if (!url || typeof url !== 'string') return '';

  const trimmed = url.trim();
  if (!trimmed) return '';

  const hasProtocol = /^https?:\/\//i.test(trimmed);
  const hasSlash = trimmed.startsWith('/');

  switch (checkFor) {
    case 'slash':
      // If it's already a protocol URL or starts with '/', leave it alone.
      // Otherwise, prepend a slash.
      if (hasProtocol || hasSlash) return trimmed;
      return `/${trimmed}`;

    case 'http':
      // Ensure the URL starts with http:// (not https)
      if (/^http:\/\//i.test(trimmed)) return trimmed;
      if (/^https:\/\//i.test(trimmed)) return trimmed.replace(/^https:\/\//i, 'http://');
      if (hasSlash) return trimmed; // relative path — leave alone
      return `http://${trimmed}`;

    case 'https':
      // Ensure the URL starts with https://
      if (/^https:\/\//i.test(trimmed)) return trimmed;
      if (/^http:\/\//i.test(trimmed)) return trimmed.replace(/^http:\/\//i, 'https://');
      if (hasSlash) return trimmed; // relative path — leave alone
      return `https://${trimmed}`;

    case 'protocol':
      // Ensure the URL has *some* protocol (http or https)
      if (hasProtocol) return trimmed;
      if (hasSlash) return trimmed; // relative path — leave alone
      return `https://${trimmed}`;  // default to https

    default:
      // Unknown mode — just ensure a leading slash
      if (hasProtocol || hasSlash) return trimmed;
      return `/${trimmed}`;
  }
};